import React, { useEffect } from 'react';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import InputField from '../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import useWorkplaceMeta from '../../../Hooks/useWorkplaceMeta';
import { MetaKey } from '../../../../Meta/Enums/MetaKey.enum';
import useMeta from '../../../../Meta/Hooks/useMeta';

const validationSchema = yup.object({
	providerCode: yup
		.string()
		.required('validation.rootWorkplaceSettingsSlovakia.providerCode'),
});

interface Props {
	rootWorkplaceId: string;
	onSuccess: () => void;
}

const RootWorkplaceSettingsSlovakia: React.FC<Props> = ({
	rootWorkplaceId,
	onSuccess,
}) => {
	const { workplaceMeta, reFetchWorkplaceMeta } = useWorkplaceMeta({
		workplaceId: rootWorkplaceId,
	});
	const { createWorkplaceMeta } = useMeta();

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	useEffect(() => {
		const providerCode = workplaceMeta[MetaKey.PROVIDER_CODE];
		if (providerCode) {
			formMethods.reset({
				providerCode,
			});
		}
	}, [workplaceMeta]);

	const handleSubmit = async (values: any) => {
		const result = await createWorkplaceMeta({
			workplaceId: rootWorkplaceId,
			meta: {
				key: MetaKey.PROVIDER_CODE,
				value: values.providerCode,
			},
		});
		if (result.status === 200) {
			reFetchWorkplaceMeta();
			onSuccess();
		}
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputField
				label='component.rootWorkplaceSettingsSlovakia.providerCode'
				name='providerCode'
				isWrapped
				isRequired
			/>
			<SubmitButton onSubmit={handleSubmit} title='base.shared.save' />
		</FormWrapper>
	);
};

export default RootWorkplaceSettingsSlovakia;
